// extracted by mini-css-extract-plugin
module.exports = {"confirm":"A7LLxHpj","content":"rw2g1Yoi","icon":"__5_52ktYj","success":"p3KiboRu"};